var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "class-emotion-rank" },
    [
      _c(
        "div",
        {
          staticClass: "flex-between",
          staticStyle: { "margin-bottom": "15px" },
        },
        [_c("span", { staticClass: "card-title" }, [_vm._v(_vm._s(_vm.title))])]
      ),
      _c("TableList", {
        staticStyle: { width: "100%" },
        attrs: {
          columns: _vm.columns,
          tableData: _vm.dataSource,
          loading: _vm.loading,
          pagination: _vm.tablePagination,
          rowKey: _vm.rowKey,
          scroll: {},
        },
        on: { change: _vm.handleTableChange },
        scopedSlots: _vm._u([
          {
            key: "diffValue",
            fn: function ({ text }) {
              return [
                Number(text) > 0
                  ? _c(
                      "span",
                      { staticClass: "diff-up" },
                      [
                        _c("a-icon", {
                          staticStyle: { "font-size": "12px" },
                          attrs: { type: "arrow-up" },
                        }),
                        _vm._v(
                          "\n        " +
                            _vm._s(Math.abs(Number(text))) +
                            "\n      "
                        ),
                      ],
                      1
                    )
                  : Number(text) < 0
                  ? _c(
                      "span",
                      { staticClass: "diff-down" },
                      [
                        _c("a-icon", {
                          staticStyle: { "font-size": "12px" },
                          attrs: { type: "arrow-down" },
                        }),
                        _vm._v(
                          "\n        " +
                            _vm._s(Math.abs(Number(text))) +
                            "\n      "
                        ),
                      ],
                      1
                    )
                  : _c("span", [_vm._v("与上月持平")]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }